<template>
  <div class="bg-white pt-12 px-4">
    <MultilangHtml class="uppercase text-2xl md:text-5xl font-semibold text-center" :html="t('home.bundle.title')" />
    <MultilangHtml class="uppercase text-2xl md:text-5xl font-semibold text-center" :html="t('home.bundle.subtitle')" />

    <div class="mt-8 md:mt-10 flex flex-col md:flex-row w-full justify-center gap-8">
      <div class="relative w-full md:w-[595px] h-[820px] md:h-[720px] overflow-hidden rounded-3xl bg-neutral-800">
        <svg class="absolute bottom-0 z-0" width="595" height="445" viewBox="0 0 595 445" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_185_2532)">
            <circle cx="298" cy="480" r="326" transform="rotate(-90 298 480)" fill="url(#paint0_linear_185_2532)" style="" />
          </g>
          <defs>
            <filter id="filter0_f_185_2532" x="-182" y="0" width="960" height="960" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="77" result="effect1_foregroundBlur_185_2532" />
            </filter>
            <linearGradient id="paint0_linear_185_2532" x1="-28" y1="92.5" x2="570" y2="466" gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FA3EF" stop-opacity="0.3" style="stop-color:#6FA3EF;stop-color:color(display-p3 0.4353 0.6392 0.9373);stop-opacity:0.3;" />
            </linearGradient>
          </defs>
        </svg>

        <div class="absolute bottom-8 right-8">
          <img src="@/assets/images/starter-s.webp" />
        </div>

        <div class="md:absolute w-full h-full p-6 z-10">
          <MultilangHtml class="mt-8 text-white text-center text-4xl font-medium" :html="t('home.bundle.bundleStarter.name')" />
          <MultilangHtml class="mt-11 text-neutral-400 text-xl md:text-3xl" :html="t('home.bundle.bundleStarter.price')" />
          <MultilangHtml class="mt-4 text-neutral-400 text-md md:text-lg" :html="t('home.bundle.bundleStarter.priceMonthly')" />
          <VaButton :to="{ name: 'products', params: { product: 'starter' } }" class="mt-14 w-full h-[70px]" round background-opacity="0.2" color="white" border-color="neutral-500">
            <div class="flex flex-row items-center gap-4">
              <div>
                <StartIcon class="w-7 h-7" />
              </div>
              <span class="text-2xl">{{ t('home.bundle.moreInfo') }}</span>
            </div>
          </VaButton>
          <div class="mt-11 text-neutral-400 text-lg">
            {{ t('home.bundle.youGet') }}
          </div>
          <div class="mt-4 flex flex-col gap-7 text-lg">
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.posSystem') }}
            </div>
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.printer') }}
            </div>
          </div>
        </div>
      </div>
      <div class="relative w-full md:w-[595px] overflow-hidden h-[950px] md:h-[720px] rounded-3xl bg-neutral-800">
        <svg class="absolute bottom-0 z-0" width="595" height="548" viewBox="0 0 595 548" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_185_2568)">
            <circle cx="298" cy="660" r="326" transform="rotate(-90 298 660)" fill="url(#paint0_linear_185_2568)" style="" />
          </g>
          <defs>
            <filter id="filter0_f_185_2568" x="-362" y="0" width="1320" height="1320" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="167" result="effect1_foregroundBlur_185_2568" />
            </filter>
            <linearGradient id="paint0_linear_185_2568" x1="-28" y1="272.5" x2="570" y2="646" gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FA3EF" style="stop-color:#6FA3EF;stop-color:color(display-p3 0.4353 0.6392 0.9373);stop-opacity:1;" />
              <stop offset="0.5" stop-color="#A36BC4" style="stop-color:#A36BC4;stop-color:color(display-p3 0.6392 0.4196 0.7686);stop-opacity:1;" />
              <stop offset="1" stop-color="#FC6F5A" style="stop-color:#FC6F5A;stop-color:color(display-p3 0.9882 0.4353 0.3529);stop-opacity:1;" />
            </linearGradient>
          </defs>
        </svg>

        <div class="absolute bottom-8 right-8">
          <img src="@/assets/images/pro-s.webp" />
        </div>

        <div class="md:absolute w-full h-full p-6 z-10">
          <MultilangHtml class="mt-8 text-white text-center text-4xl font-medium" :html="t('home.bundle.bundlePro.name')" />
          <MultilangHtml class="mt-11 text-neutral-400 text-xl md:text-3xl" :html="t('home.bundle.bundlePro.price')" />
          <MultilangHtml class="mt-4 text-neutral-400 text-md md:text-lg" :html="t('home.bundle.bundlePro.priceMonthly')" />
          <VaButton :to="{ name: 'products', params: { product: 'pro' } }" class="mt-14 w-full h-[70px]" round background-opacity="0.2" color="white" border-color="neutral-500">
            <div class="flex flex-row items-center gap-4">
              <div>
                <StartIcon class="w-7 h-7" />
              </div>
              <span class="text-2xl">{{ t('home.bundle.moreInfo') }}</span>
            </div>
          </VaButton>
          <div class="mt-11 text-neutral-400 text-lg">
            {{ t('home.bundle.youGet') }}
          </div>
          <div class="mt-4 flex flex-col gap-7 text-lg">
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.posSystem') }}
            </div>
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.customerDisplay') }}
            </div>
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.cashDrawer') }}
            </div>
            <div class="flex flex-row items-center gap-2.5 text-white">
              <CheckIcon class="w-6 h-6" />
              {{ t('home.bundle.items.printer') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-10 mb-20">
      <p v-if="!isPricing">{{ t('home.bundle.combine') }} → <RouterLink :to="{ name: 'pricing' }">{{ t('home.bundle.priceLink') }}</RouterLink></p>

      <VaButton preset="secondary" border-color="black" color="black" round class="h-[68px] !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'appointment' }">
        <span class="ml-2.5">{{ t('common.bookDemo') }}</span>
        <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
          <ArrowRight class="w-4" />
        </div>
      </VaButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import CheckIcon from '@/assets/icons/check.svg'
import MultilangHtml from '@/components/MultilangHtml.vue'
import StartIcon from '@/assets/icons/start.svg'
import ArrowRight from '@/assets/icons/arrow-right.svg'

const { t } = useI18n()

defineProps<{
  isPricing?: boolean,
}>()
</script>
